import * as React from "react";

import RegisterView from "../modules/Register";

export default function RegisterPage() {
  return <RegisterView />;
}
